/**
 * Función que aplica el debounce (retraso) a una función
 *
 * @param {string} func Función a la que se le aplicará el debounce
 * @param {number} wait Tiempo de espera
 * @returns {function} Función que aplica el debounce
 */
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export default debounce;
